















































































































































































































































































































































































































































































































































































































































































import {
  computed,
  watch,
  ref,
  defineComponent,
  useRoute,
  onMounted,
} from "@nuxtjs/composition-api";
import { useCategoryMenuStore } from "~/stores/extensionApi";
import HeaderLogo from "~/components/Header/HeaderLogo.vue";
import { checkCmsLink, urlImage, changeImage, direct_link } from "~/helpers";
import {
  checkLengthDataCategory,
  checkLength,
  checkLengthCategory,
  findParent,
} from "~/modules/catalog/category/helpers";

export default defineComponent({
  components: {
    HeaderLogo,
  },
  setup() {
    const route = useRoute();

    const categoryMenuStore = useCategoryMenuStore();
    const newMegaMenu = computed(() => categoryMenuStore.getCategoryMenuMega);

    const isHoveredMenu = ref(false);
    const isHideMegaMenu = ref(false);
    const parentCategory = ref(null);

    const getCategoryEnabled = (category) => {
      let menu1 = category?.filter((e) => e.itemEnable === "1");
      var result = [];
      menu1?.forEach((element) => {
        result.push(element);
      });
      return result;
    };

    const isCategoryActive = (index1) => {
      let url_path = route.value?.path?.replace("/", "");
      if (newMegaMenu && newMegaMenu.value.length > 0 && url_path) {
        const index = findParent(newMegaMenu.value, "link", url_path);
        if (index >= 0 && index == index1) {
          return true;
        } else {
          return false;
        }
      }
    };

    const getDataCategory = (category, a, b) => {
      let menu1 = category?.filter((e) => e.itemPosition == a);
      let menu2 = category?.filter((e) => e.itemPosition == b);
      var result = [];
      menu1?.forEach((element) => {
        result.push(element);
      });
      menu2?.forEach((element) => {
        result.push(element);
      });
      return result;
    };

    watch(route, (to, from) => {
      isHideMegaMenu.value = true;
      parentCategory.value = null;
      setTimeout(() => {
        isHideMegaMenu.value = false;
      }, 100);
    });

    onMounted(async () => {
      if (
        !categoryMenuStore.getCategoryMenuMega ||
        categoryMenuStore.getCategoryMenuMega.length === 0
      ) {
        await categoryMenuStore.loadNewMenuMega();
      }
    });

    return {
      checkLengthDataCategory,
      checkCmsLink,
      direct_link,
      checkLength,
      checkLengthCategory,
      findParent,
      urlImage,
      changeImage,
      getCategoryEnabled,
      newMegaMenu,
      getDataCategory,
      isCategoryActive,
      isHoveredMenu,
      isHideMegaMenu,
      parentCategory,
    };
  },
  data() {
    return {
      activeIndex: null,
      boundClickHandler: null as any,
    };
  },
  methods: {
    setActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
        this.isHoveredMenu = true;
      }
      this.updateBodyOverflow();
    },
    closeMenu() {
      this.activeIndex = null;
      this.updateBodyOverflow();
    },
    handleClickOutside(event) {
      const listEl = this.$refs.list as HTMLElement;

      if (listEl && !listEl.contains(event.target as Node)) {
        this.activeIndex = null;
        this.updateBodyOverflow();
      }
    },
    updateBodyOverflow() {
      if (
        this.activeIndex !== null &&
        this.newMegaMenu[this.activeIndex] &&
        this.checkLength(this.newMegaMenu[this.activeIndex].childrenraw)
      ) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
  },
  computed: {
    hasActive(): boolean {
      return this.activeIndex !== null;
    },
  },
  watch: {
    activeIndex() {
      this.updateBodyOverflow();
    },
  },
  mounted() {
    document.addEventListener(
      "click",
      this.handleClickOutside as EventListener
    );
  },
  beforeDestroy() {
    document.removeEventListener(
      "click",
      this.handleClickOutside as EventListener
    );
    // Ensure we reset body overflow when component is destroyed
    document.body.style.overflow = "";
  },
});
